/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export function Icon21Icon(props) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      xmlnsXlink={"http://www.w3.org/1999/xlink"}
      fill={"none"}
      viewBox={"0 0 20 20"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <g
        stroke={"#292929"}
        strokeLinecap={"round"}
        strokeLinejoin={"round"}
        clipPath={"url(#a)"}
      >
        <path
          d={
            "m8.567 7.09.999 2.295a.5.5 0 0 0 .183.084 1 1 0 0 0 .502 0q.117-.03.183-.084l1.002-2.295H15.5a.9.9 0 0 0 .354-.067c.093-.042.146-.1.146-.16V3.227c0-.06-.053-.118-.146-.16A.9.9 0 0 0 15.5 3h-11a.9.9 0 0 0-.354.067c-.093.042-.146.1-.146.16v3.636c0 .06.053.118.146.16a.9.9 0 0 0 .354.067zM12 15c1.227 0 2.5.5 3 2m-7-1a2 2 0 1 0 0-4 2 2 0 0 0 0 4m-3 2a3.8 3.8 0 0 1 1.272-1.465A3.1 3.1 0 0 1 8 16c.606 0 1.201.184 1.728.535S10.692 17.391 11 18m-.603-6.269q.078-.095.17-.18a2.06 2.06 0 0 1 2.106-.427c.356.13.668.355.9.65a1.98 1.98 0 0 1 .22 2.106 2 2 0 0 1-.75.817A2.06 2.06 0 0 1 11.97 15"
          }
        ></path>
      </g>

      <defs>
        <clipPath id={"a"}>
          <path fill={"#fff"} d={"M0 0h20v20H0z"}></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon21Icon;
/* prettier-ignore-end */
